import React, { useState } from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import './styles.css';
import { useSelectedLayout } from '../../../../../../../../store/useSelectedLayout';
import ButtonRecordVideo from '../../buttons/buttonForToolBarDeviceOne/ButtonRecordVideo';
import ButtonTakeAPhoto from '../../buttons/buttonForToolBarDeviceOne/ButtonTakeAPhoto';
import ButtonRecordAudio from '../../buttons/buttonForToolBarDeviceOne/ButtonRecordAudio';
import ButtonShowMap from '../../buttons/buttonForToolBarDeviceOne/ButtonShowMap';
import useRecordingStore from '../../../api/recording/recordingStore';
import { Device } from '../../../../../../../../types/Device';
import ButtonLayoutViewStyle from '../../buttons/buttonLayout/buttonLayoutViewStyle';
import useNotification from '../../../../../../../../utils/features/hooks/useNotification';

interface HeaderProps {
    isEdit: boolean;
    handleExitEditMode: () => void;
    handleBackToAllDevice: () => void;
    onShowMap: () => void;
    devices: Device[] | [];
    isMapVisible: boolean;
    handleSelectLayoutView: (size: any) => void;
}

const LayoutHeader: React.FC<HeaderProps> = ({
    isEdit,
    handleExitEditMode,
    handleBackToAllDevice,
    onShowMap,
    devices,
    isMapVisible,
    handleSelectLayoutView,
}) => {
    const { selectedLayout } = useSelectedLayout();
    const {
        getDeviceRecordingType,
        setIsAudioModalVisible,
        setIsVideoModalVisible,
        setIsPhotoModalVisible,
        isDeviceRecording,
    } = useRecordingStore();
    const { showNotification, contextHolderr } = useNotification();

    const haveDeviceOnline = devices?.some((device) => device.online);

    // Проверяем, есть ли устройства, доступные для записи видео
    const canStartVideo = devices?.some((device) => {
        if (!device.online) {
            return false;
        } // Устройство должно быть онлайн
        const isRecording = isDeviceRecording(device);
        const recordingType = getDeviceRecordingType(device);
        console.log('video', [recordingType, device]);

        if (isRecording && recordingType == 'audio') {
            return true;
        }

        if (!isRecording) {
            return true;
        }
    });

    // Проверяем, есть ли устройства, доступные для записи аудио
    const canStartAudio = devices?.some((device) => {
        if (!device.online) {
            return false;
        } // Устройство должно быть онлайн
        const isRecording = isDeviceRecording(device);
        const recordingType = getDeviceRecordingType(device);

        if (!isRecording) {
            return true;
        }
    });

    // Проверяем, есть ли устройства, доступные для фото
    const canTakePhoto = devices?.some((device) => device.online);

    const handleRecordButtonClick = (type: 'audio' | 'video' | 'photo') => {
        // Фильтруем только онлайн устройства, доступные для данного типа записи
        const availableDevices = devices?.filter((device) => {
            if (!device.online) return false;

            const isRecording = isDeviceRecording(device);
            const recordingType = getDeviceRecordingType(device);

            if (type === 'video') {
                if (isRecording && recordingType == 'audio') {
                    return true;
                }

                if (!isRecording) {
                    return true;
                }
            } else if (type === 'audio') {
                if (!isRecording) {
                    return true;
                }
            }
            // Для фото доступны все онлайн устройства
            return true;
        });

        if (availableDevices?.length === 0) {
            showNotification('error', 'Ошибка', 'Нет доступных устройств для этого типа записи');
            return;
        }

        // Показываем модалку для выбранного типа
        if (type === 'audio') {
            setIsAudioModalVisible(true);
        } else if (type === 'video') {
            setIsVideoModalVisible(true);
        } else {
            setIsPhotoModalVisible(true);
        }
    };

    return (
        <>
            {contextHolderr}
            <div
                className="header_layout"
                style={{
                    display: 'flex',
                    transition: 'margin-right 0.3s ease',
                    justifyContent: 'space-between',
                    paddingBottom: 8,
                    borderBottom: '1px solid var(--divider-2)',
                    marginBottom: 16,
                    alignItems: 'center',
                }}
            >
                <div className="left_HT">
                    {isEdit ? (
                        <Button
                            className="buttonLeft headline small"
                            icon={<ArrowLeftOutlined />}
                            style={{
                                border: 'none',
                                backgroundColor: 'none',
                                boxShadow: 'none',
                            }}
                            onClick={handleExitEditMode}
                        >
                            Раскладка: режим редактирования
                        </Button>
                    ) : (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Button
                                className="buttonLeft headline small"
                                icon={<ArrowLeftOutlined />}
                                style={{
                                    border: 'none',
                                    backgroundColor: 'none',
                                    boxShadow: 'none',
                                }}
                                onClick={handleBackToAllDevice}
                            >
                                {selectedLayout?.name}
                            </Button>
                            <span style={{ marginLeft: 49 }}>{selectedLayout?.description}</span>
                        </div>
                    )}
                </div>
                <div className="right_HT">
                    {isEdit ? (
                        <ButtonLayoutViewStyle
                            onFilterButtonClick={handleSelectLayoutView}
                            activeButton={selectedLayout?.viewType}
                        />
                    ) : (
                        <div className="rightSideToolBar">
                            <ButtonRecordVideo
                                disabled={!canStartVideo}
                                handleRecordButtonClick={handleRecordButtonClick}
                            />
                            <ButtonTakeAPhoto
                                disabled={!haveDeviceOnline}
                                handleRecordButtonClick={handleRecordButtonClick}
                            />
                            <ButtonRecordAudio
                                // onClick={() => setIsAudioModalVisible(true)}
                                disabled={!canStartAudio}
                                handleRecordButtonClick={handleRecordButtonClick}
                            />
                            <ButtonShowMap onClick={onShowMap} isMapVisible={isMapVisible} />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default LayoutHeader;
